/* eslint-disable eqeqeq */
import moment from "moment";
import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import BlockUi from "react-block-ui";
import { CSVLink } from "react-csv";
import { Loader } from "react-loaders";
import ReactTable from "react-table";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Row
} from "reactstrap";
import SearchBar from "../../../common/Search/SearchBar";
import { headers_module_calibration } from "../../../data/headers_CSV";
import * as PicaCSVzService from "../../../services/clients/api_pica_cs_vz";
import RowDetails from "./RowDetails";

const TABLE_PAGE_OFFSET = 1;

const dateToday = new Date();
var dateYesterday = new Date();
const dateOffset = 24 * 60 * 60 * 1000; // 1 day
dateYesterday.setTime(dateYesterday.getTime() - dateOffset);

export default class PicaCSVzTable extends React.Component {
  constructor(props) {
    super();
    this.state = {
      expanded: {},
      calibrations: [],
      pages: 0, // should default to -1 (which means we don't know how many pages we have)
      loading: true,
      blocking: true,
      showAdvancedOptions: false,
      searchText: "",
      startDate: moment(dateYesterday.getTime()),
      endDate: moment(dateToday.getTime()),
      page: 0,
      totalPages: 1,
      csvData: [],
      loadCSV: false,
      loaderType: "ball-pulse",
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /*********************************** ACTION METHODS ***********************************/
  handleKeyPress = (target) => {
    if (target.charCode == 13) {
      // Enter:
      this.refreshTable();
    }
  };

  handleSearch = () => {
    // Call endpoint:
    this.refreshTable();
  };

  refreshTable = () => {
    this.setState({
      loading: true,
      blocking: true,
      calibrations: [],
    });

    if (this.refReactTable) {
      this.refReactTable.fireFetchData();
    }
  };
  async getCSV() {
    const {
      showAdvancedOptions,
      startDate,
      endDate,
      status,
      page,
      csvData,
      totalPages,
    } = this.state;

    const payload = {
      serialNumber: this.props.serialNumber
        ? this.props.serialNumber
        : this.state.searchText,
      startDate: showAdvancedOptions ? startDate.valueOf() : undefined,
      endDate: showAdvancedOptions ? endDate.valueOf() : undefined,
      status:
        showAdvancedOptions && status != "" && status != "SELECT"
          ? status
          : undefined,
    };

    if (page <= totalPages) {
      const _this = this;
      PicaCSVzService.search(
        payload,
        page + TABLE_PAGE_OFFSET,
        100,

        function(result) {
          const docs = result.data.docs;
          for (var i = 0; i < result.data.docs.length; i++) {
            var newLine = { ...docs[i] };
            newLine.startDate = moment(newLine.startDate, "x").format(
              "DD/MM/YYYY HH:mm:ss"
            );
            if (newLine.endDate != undefined) {
              newLine.endDate = moment(newLine.endDate, "x").format(
                "DD/MM/YYYY HH:mm:ss"
              );
            }
            if (newLine.updateDate != undefined) {
              newLine.updateDate = moment(newLine.updateDate, "x").format(
                "DD/MM/YYYY HH:mm:ss"
              );
            }
            csvData.push(newLine);
          }
          _this.setState(
            {
              csvData,
              page: page + 1,
              totalPages: result.data.totalPages,
              loadCSV: true,
            },
            () => {
              _this.getCSV();
            }
          );
        }
      );
    } else {
      this.setState({ loadCSV: false }, () => {
        // click the CSVLink component to trigger the CSV download
        this.csvLink.link.click();
      });
    }
  }
  handleDownload = () => {
    this.setState(
      {
        csvData: [],
        page: 0,
      },
      () => {
        this.getCSV();
      }
    );
  };
  handleChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };
  handleAdvancedOpt = ({ newShowAdvancedOptions }) => {
    this.setState(
      {
        showAdvancedOptions: newShowAdvancedOptions,
      },
      () => {
        if (!newShowAdvancedOptions) this.refreshTable();
      }
    );
  };

  handleStatus = ({ selectedValue }) => {
    this.setState({ status: selectedValue });
  };

  /*********************************** RENDER ***********************************/
  render() {
    const { calibrations, loadCSV, csvData } = this.state;
    const {
      showOnStation,
      serialNumber,
      selectedStationId,
      graphData,
    } = this.props;
    if (graphData && graphData.length > 0) {
      const docs = graphData[0].data.docs;
      var serialNumberArray = docs.map((item) => item.serialNumber);
    }
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col md="12">
              <BlockUi
                tag="div"
                blocking={this.state.blocking}
                loader={<Loader active type={this.props.loaderType} />}
              >
                <Card className="main-card mb-3">
                  <CardHeader className="card-header-tab">
                    <div className="card-header-title">
                      <i className="header-icon lnr-layers"> </i>
                      Results
                    </div>

                    <div className="btn-actions-pane-right text-capitalize">
                      {selectedStationId !== undefined ? (
                        <span
                          className="d-inline-block"
                          style={{ verticalAlign: "-webkit-baseline-middle" }}
                        >
                          <Button
                            className="mr-2"
                            color="danger"
                            style={{ color: "white" }}
                            onClick={this.props.onClearFilter}
                          >
                            Clear Filter
                          </Button>
                        </span>
                      ) : (
                        ""
                      )}
                      {serialNumber ? (
                        ""
                      ) : showOnStation ? (
                        <span
                          className="d-inline-block"
                          style={{
                            verticalAlign: "-webkit-baseline-middle",
                          }}
                        >
                          <Button
                            className="mr-2 btn-icon"
                            color="primary"
                            onClick={this.props.onHideStation}
                          >
                            Showing On Station
                            <i className="pe-7s-close-circle btn-icon-wrapper ml-2 mr-0">
                              {" "}
                            </i>
                          </Button>
                        </span>
                      ) : (
                        <div>
                          <CSVLink
                            headers={headers_module_calibration}
                            data={csvData}
                            target="_blank"
                            filename={"headers_module_calibration.csv"}
                            ref={(r) => (this.csvLink = r)}
                          />
                          <div
                            className="d-inline-block ml-2"
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            <BlockUi
                              tag="div"
                              blocking={loadCSV}
                              className="block-overlay-light"
                              loader={
                                <Loader
                                  color="#ffffff"
                                  active
                                  type={this.state.loaderType}
                                />
                              }
                            >
                              <Button
                                className="pl-1"
                                color="info"
                                onClick={this.handleDownload}
                              >
                                <i
                                  onClick={this.handleDownload}
                                  className="lnr-download ml-2"
                                  style={{
                                    fontSize: "16px",
                                    verticalAlign: "text-bottom",
                                    marginRight: "8px",
                                  }}
                                />
                                Download
                              </Button>
                            </BlockUi>
                          </div>
                          <div
                            className="d-inline-block ml-2"
                            style={{
                              marginRight: "10px",
                              verticalAlign: "middle",
                            }}
                          >
                            <InputGroup>
                              <Input
                                placeholder="Serial Number"
                                onChange={(e) => {
                                  this.setState({
                                    searchText: e.target.value,
                                  });
                                }}
                                onKeyPress={this.handleKeyPress}
                              />
                              <InputGroupAddon addonType="append">
                                <Button
                                  color="info"
                                  onClick={this.handleSearch}
                                >
                                  <i className="lnr-magnifier"> </i>
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </div>
                        </div>
                      )}
                    </div>
                  </CardHeader>
                  {serialNumber ? (
                    ""
                  ) : (
                    <SearchBar
                      handleChange={this.handleChange}
                      refreshTable={this.refreshTable}
                      handleStatus={this.handleStatus}
                      handleAdvancedOpt={this.handleAdvancedOpt}
                    />
                  )}
                  <CardBody style={{ padding: "0px", maxWidth: "100vw" }}>
                    <ReactTable
                      ref={(refReactTable) => {
                        this.refReactTable = refReactTable;
                      }}
                      data={calibrations}
                      collapseOnDataChange={false}
                      /*
                       * Expand only 1 row at a time:
                      expanded={this.state.expanded}
                      onExpandedChange={(newExpanded, index, event) => {
                        console.log("### onExpandedChange");
                        if (newExpanded[index[0]] === false) {
                          newExpanded = {};
                        } else {
                          Object.keys(newExpanded).map(k => {
                            newExpanded[k] =
                              parseInt(k) === index[0] ? {} : false;
                          });
                        }
                        this.setState({ expanded: newExpanded });
                      }}
                      */
                      columns={[
                        {
                          expander: true,
                          width: 40,
                          Expander: ({ isExpanded, ...rest }) => {
                            return (
                              <div
                                style={{
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                {isExpanded ? (
                                  <i className="lnr-circle-minus"> </i>
                                ) : (
                                  <i className="lnr-plus-circle"> </i>
                                )}
                              </div>
                            );
                          },
                        },
                        {
                          Header: "Serial Number",
                          id: "serialNumber",
                          accessor: (d) => d.serialNumber,
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.value}
                            </div>
                          ),
                          minWidth: 110,
                          sortable: false,
                        },

                        // from UPSTREAM
                        {
                          Header: "Sen Ch1",
                          accessor: "usSenInputCh1",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usInputlockOntCh1 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 86,
                          sortable: false,
                        },
                        {
                          Header: "Sen Ch2",
                          accessor: "usSenInputCh2",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usInputlockOntCh2 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 86,
                          sortable: false,
                        },
                        {
                          Header: "Sen Ch3",
                          accessor: "usSenInputCh3",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usInputlockOntCh3 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 86,
                          sortable: false,
                        },
                        {
                          Header: "Sen Ch4",
                          accessor: "usSenInputCh4",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usInputlockOntCh4 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 88,
                          sortable: false,
                        },
                        {
                          Header: "OPP Ch1",
                          accessor: "dispPenCh1",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usFiberlockOntCh1 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 86,
                          sortable: false,
                        },
                        {
                          Header: "OPP Ch2",
                          accessor: "dispPenCh2",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usFiberlockOntCh2 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 86,
                          sortable: false,
                        },
                        {
                          Header: "OPP Ch3",
                          accessor: "dispPenCh3",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usFiberlockOntCh3 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 86,
                          sortable: false,
                        },
                        {
                          Header: "OPP Ch4",
                          accessor: "dispPenCh4",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.original.usFiberlockOntCh4 == "NO" ? (
                                <div className="badge badge-danger">N LOCK</div>
                              ) : props.value != undefined ? (
                                props.value.toFixed(1)
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          minWidth: 86,
                          sortable: false,
                        },

                        // =================

                        {
                          Header: "Date",
                          id: "startDate",
                          style: {
                            textAlign: "center",
                          },
                          accessor: (d) =>
                            d.startDate
                              ? moment(d.startDate, "x").format("DD/MM/YYYY")
                              : "...",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.value}
                            </div>
                          ),
                          minWidth: 80,
                          sortable: false,
                        },
                        {
                          Header: "Debug",
                          id: "debug",
                          style: { textAlign: "center" },
                          accessor: (d) =>
                            d.debug !== undefined && d.debug != null
                              ? d.debug
                              : false,
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.value === true ? (
                                <i className="lnr-warning"> </i>
                              ) : (
                                "-"
                              )}
                            </div>
                          ),
                          width: 70,
                          sortable: false,
                        },
                        {
                          Header: "Err",
                          accessor: "errorNumber",
                          Cell: (props) => (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {props.value ? props.value : "-"}
                            </div>
                          ),
                          minWidth: 60,
                          sortable: false,
                        },
                        {
                          Header: "Pass",
                          id: "pass",
                          style: {
                            textAlign: "center",
                          },
                          accessor: (d) => d.pass,
                          Cell: (props) =>
                            props.value &&
                            props.value.toUpperCase() === "PASS" ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                <div className="badge badge-success">PASS</div>
                              </div>
                            ) : props.value &&
                              props.value.toUpperCase() === "FAIL" ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                <div className="badge badge-danger">FAIL</div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                <div className="loader loader-undefined loader-active opacity-3">
                                  <div className="loader-inner line-scale">
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                  </div>
                                </div>
                              </div>
                            ),
                          minWidth: 80,
                          sortable: false,
                        },
                      ]}
                      SubComponent={(row) => {
                        const index =
                          row !== undefined && row.index !== undefined
                            ? row.index
                            : -1;

                        if (index !== -1) {
                          if (this.state.calibrations[index] !== undefined) {
                            const moduleCalibration = this.state.calibrations[
                              index
                            ];
                            return (
                              <Fragment>
                                <div
                                  style={{
                                    width: "100%",
                                    height: "1px",
                                    backgroundColor: "rgba(146, 150, 154, 0.6)",
                                  }}
                                />
                                <div
                                  style={{
                                    padding: "20px 20px 20px 48px",
                                    backgroundColor: "#fafafa",
                                  }}
                                >
                                  <RowDetails
                                    moduleCalibration={moduleCalibration}
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    height: "1px",
                                    backgroundColor: "rgba(146, 150, 154, 0.6)",
                                  }}
                                />
                              </Fragment>
                            );
                          } else {
                            return (
                              <div
                                style={{
                                  padding: "20px",
                                }}
                              >
                                <em>Calibration not found!</em>
                              </div>
                            );
                          }
                        } else {
                          return (
                            <div
                              style={{
                                padding: "20px",
                              }}
                            >
                              <em>Error getting index!</em>
                            </div>
                          );
                        }
                      }}
                      defaultPageSize={25 /*Math.min(10, burnins.length)*/}
                      className="-striped -highlight"
                      pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000]}
                      manual // informs React Table that you'll be handling sorting and pagination server-side
                      pages={this.state.pages}
                      onFetchData={(state, instance) => {
                        const _this = this;

                        // show the loading overlay
                        this.setState({
                          loading: true,
                          blocking: true,
                        });

                        const {
                          showAdvancedOptions,
                          startDate,
                          endDate,
                          status,
                        } = this.state;
                        if (this.state.searchText) {
                          serialNumberArray = [];
                        }
                        // ----------------------- PAYLOAD -----------------------
                        const payload = {
                          onStation: showOnStation == true ? true : undefined,
                          serialNumber: this.props.serialNumber
                            ? this.props.serialNumber
                            : this.state.searchText,
                          startDate: showAdvancedOptions
                            ? startDate.valueOf()
                            : undefined,
                          endDate: showAdvancedOptions
                            ? endDate.valueOf()
                            : undefined,
                          status:
                            showAdvancedOptions &&
                            status != "" &&
                            status != "SELECT"
                              ? status
                              : undefined,
                          stationID: selectedStationId,
                          serialNumberArray:
                            serialNumberArray !== undefined &&
                            serialNumberArray !== null
                              ? serialNumberArray
                              : undefined,
                        };
                        // fetch your data
                        PicaCSVzService.search(
                          payload,
                          state.page + TABLE_PAGE_OFFSET,
                          state.pageSize,
                          function(result) {
                            // Fill data:
                            _this.setState({
                              calibrations: result.data.docs,
                              pages: result.data.totalPages,
                              loading: false,
                              blocking: false,
                            });
                          }
                        );

                        if (this.props.handleSearchStats) {
                          if (showAdvancedOptions == true) {
                            this.props.handleSearchStats(
                              startDate.valueOf(),
                              endDate.valueOf()
                            );
                          } else {
                            this.props.handleSearchStats(null, null);
                          }
                        }
                      }}
                    />
                  </CardBody>
                </Card>
              </BlockUi>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Clients/PicaC&SVz/components/PicaC&SVzTable.js